import React, { Component } from 'react';
import { DatePicker, Form, Input, message, Modal, Row, Select, TreeSelect } from 'antd';
import moment from 'moment';

import { queryXxOrg } from '@api/xxcrm/invoice';
import { queryAccountList } from '@api/core/user';
import { queryOrgList } from '@api/core/org';
import base from '@util/base';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      treeData: [],
      accountList: [],
      companyList: [],
      data: this.props.record || {},
    };
  }

  componentDidMount() {
    const { data } = this.state;
    this.companyName = data.companyName || '';
    this.orgName = data.orgName || '';
    this.cusrName = data.cusrName || '';
    const { orgUuid } = this.state.data;
    this.loadOrg();
    this.loadCompanyList();
    if (orgUuid) {
      this.loadAccount(orgUuid, true);
    } else {
      this.loadAccount();
    }
  }

  /**
   *获取用户列表
   */
  loadAccount = (orgUuid, flag) => {
    const uuid = orgUuid || '';
    queryAccountList({ orgUuid: uuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          accountList: res.data,
        });
        if (!flag) {
          this.props.form.setFieldsValue({
            cusr: undefined,
          });
        }
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 获取公司列表
   */
  loadCompanyList = () => {
    queryXxOrg().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          companyList: res.data,
        });
      }
    });
  };

  onChange = (orgUuid, label) => {
    this.orgName = label[label.length - 1];
    if (orgUuid !== this.orgUuid) {
      this.orgUuid = orgUuid;
      this.loadAccount(orgUuid);
    }
  };

  /**
   *获取组织列表
   */
  loadOrg = () => {
    const params = {};
    params.uuid = '19F83BB0108B4255AA38D457E3FFF223';
    queryOrgList(params).then(res => {
      if (res.statusCode === 200) {
        const options = [];
        res.data.map(item => {
          const optionItem = {};
          optionItem.label = item.name;
          optionItem.value = item.uuid;
          optionItem.key = item.uuid;
          options.push(optionItem);
          return options;
        });
        this.setState({
          treeData: options,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  onLoadData = treeNode => {
    const arr = [];
    const key = treeNode.props.eventKey;
    const params = {};
    params.uuid = key.split('-')[key.split('-').length - 1];
    return new Promise(resolve => {
      queryOrgList(params).then(res => {
        if (res.statusCode === 200) {
          res.data.map(item => {
            const optionItem = {};
            optionItem.label = item.name;
            optionItem.value = item.uuid;
            optionItem.key = `${key}-${item.uuid}`;
            arr.push(optionItem);
            return arr;
          });
          const treeData = [...this.state.treeData];
          const loop = data => {
            data.forEach(item => {
              if (key.indexOf(item.key) === 0) {
                if (item.children) {
                  resolve();
                  loop(item.children);
                } else if (item.key === key) {
                  if (arr.length > 0) {
                    item.children = arr;
                    this.setState({ treeData }, () => {
                      resolve();
                    });
                  } else if (arr.length === 0) {
                    item.isLeaf = true;
                    this.setState({ treeData }, () => {
                      resolve();
                    });
                  } else {
                    resolve();
                  }
                }
              }
            });
          };
          loop(treeData);
        }
      });
    });
  };

  setCusrName = (value, option) => {
    this.cusrName = option.props.children;
  };

  submit = () => {
    const data = this.props.form.getFieldsValue();
    data.orgName = this.orgName;
    data.cusrName = this.cusrName;
    data.invoiceTop = data.name;
    this.props.form.validateFields(err => {
      this.props.handSubmit(data);
    });
  };

  render() {
    const { cancel } = this.props;
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };

    const { accountList, companyList, data } = this.state;
    return (
      <Modal
        title="发票使用"
        width={420}
        style={{ paddingBottom: '0' }}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline" style={{ height: '400px', overflowY: 'scroll' }}>
          <Row>
            <FormItem label="开票类型" {...formItemLayout}>
              {getFieldDecorator('submitType', {
                rules: [{ required: true, message: '开票类型不能为空！' }],
                initialValue: data.submitType ? `${data.submitType}` : undefined,
              })(
                <Select>
                  <Option value="1">提前开票</Option>
                  <Option value="2">到账开票</Option>
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="开票日期" {...formItemLayout}>
              {getFieldDecorator('useTime', {
                rules: [{ required: true, message: '开票日期不能为空！' }],
                initialValue: data.useTime ? moment(data.useTime) : data.useTime,
              })(<DatePicker style={{ width: '100%' }} />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="合同编号" {...formItemLayout}>
              {getFieldDecorator('contractNo', {
                rules: [
                  {
                    required: true,
                    message: '合同编号不合法！',
                    pattern: /(^LXCRM\d+$)|([1-9]{2})(((0[13578]|1[02])(0[1-9]|[12]\d|3[01]))|((0[469]|11)(0[1-9]|[12]\d|30))|(02(0[1-9]|1\d|2\d)))\d{2,3}$/,
                  },
                ],
                initialValue: data.contractNo,
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="开票公司" {...formItemLayout}>
              {getFieldDecorator('company', {
                rules: [{ required: true, message: '开票公司不能为空！' }],
                initialValue: data.company && data.company !== '0' ? `${data.company}` : undefined,
              })(
                <Select disabled>
                  {companyList.map(item => {
                    return <Option key={item.uuid}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="购方名称" {...formItemLayout}>
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '购方名称不能为空！' }],
                initialValue: data.name,
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="金额" {...formItemLayout}>
              {getFieldDecorator('price', {
                rules: [{ required: true, message: '金额不合法！' }],
                initialValue: data.price || '',
              })(<Input type="number" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="购方税号" {...formItemLayout}>
              {getFieldDecorator('taxId', {
                initialValue: data.taxId,
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="不含税金额" {...formItemLayout}>
              {getFieldDecorator('noTaxPrice', {
                initialValue: data.noTaxPrice,
              })(<Input type="number" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="税率" {...formItemLayout}>
              {getFieldDecorator('taxRate', {
                initialValue: data.taxRate,
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="价税合计" {...formItemLayout}>
              {getFieldDecorator('totalPrice', {
                initialValue: data.totalPrice,
              })(<Input type="number" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="到账日期" {...formItemLayout}>
              {getFieldDecorator('collectDate', {
                initialValue: data.collectDate ? moment(data.collectDate) : data.collectDate,
              })(<DatePicker style={{ width: '100%' }} />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="收款方式" {...formItemLayout}>
              {getFieldDecorator('collectWay', {
                rules: [{ required: true, message: '收款方式不能为空！' }],
                initialValue: data.collectWay ? `${data.collectWay}` : data.collectWay,
              })(
                <Select>
                  <Option value="1">汇款</Option>
                  <Option value="2">现金</Option>
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="收款银行" {...formItemLayout}>
              {getFieldDecorator('collectBank', {
                rules: [{ required: true, message: '收款银行不能为空！' }],
                initialValue: data.collectBank ? `${data.collectBank}` : data.collectBank,
              })(
                <Select>
                  {base.bank.map(item => {
                    return <Option key={item.key}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row className="label-wrap">
            <FormItem label="本月开票金额与到账金额是否相符" {...formItemLayout}>
              {getFieldDecorator('isCorrect', {
                rules: [{ required: true, message: '不能为空！' }],
                initialValue: data.isCorrect ? `${data.isCorrect}` : data.isCorrect,
              })(
                <Select>
                  <Option value="0">是</Option>
                  <Option value="1">否</Option>
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="首款金额" {...formItemLayout}>
              {getFieldDecorator('firstPrice', {
                initialValue: data.firstPrice,
              })(<Input type="number" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="尾款金额" {...formItemLayout}>
              {getFieldDecorator('balancePrice', {
                initialValue: data.balancePrice,
              })(<Input type="number" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="回执单回收日期" {...formItemLayout}>
              {getFieldDecorator('recoverDate', {
                rules: [{ required: true, message: '回执单回收日期不能为空！' }],
                initialValue: data.recoverDate ? moment(data.recoverDate) : data.recoverDate,
              })(<DatePicker style={{ width: '100%' }} />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="申请人部门" {...formItemLayout}>
              {getFieldDecorator('orgUuid', {
                rules: [{ required: true, message: '部门不能为空！' }],
                initialValue: data.orgUuid,
              })(
                <TreeSelect
                  treeData={this.state.treeData}
                  onChange={this.onChange}
                  loadData={this.onLoadData}
                  dropdownStyle={{ maxHeight: '300px', overflowY: 'scroll' }}
                />,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="申请人" {...formItemLayout}>
              {getFieldDecorator('cusr', {
                rules: [{ required: true, message: '申请人不能为空！' }],
                initialValue: data.cusr,
              })(
                <Select onSelect={this.setCusrName}>
                  {accountList.map(item => {
                    return <Option key={item.uuid}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="领取人" {...formItemLayout}>
              {getFieldDecorator('receiveUserName', {
                initialValue: data.receiveUserName,
              })(<Input />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="备注" {...formItemLayout}>
              {getFieldDecorator('remark', {
                initialValue: data.remark,
              })(<Input />)}
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/invoice/ModalUse.js